"use client";

import { c as _c } from "react/compiler-runtime";
import MemesWaveZapIcon from "@/components/brain/left-sidebar/waves/MemesWaveZapIcon";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import React from "react";
interface MemesWaveQuickVoteTriggerProps {
  readonly isAvailable?: boolean | undefined;
  readonly className?: string | undefined;
  readonly onOpenQuickVote: () => void;
  readonly onPrefetchQuickVote?: (() => void) | undefined;
  readonly unratedCount: number;
}
const MemesWaveQuickVoteTrigger: React.FC<MemesWaveQuickVoteTriggerProps> = t0 => {
  const $ = _c(10);
  const {
    isAvailable: t1,
    className,
    onOpenQuickVote,
    onPrefetchQuickVote,
    unratedCount
  } = t0;
  const isAvailable = t1 === undefined ? true : t1;
  if (!isAvailable) {
    return null;
  }
  const label = unratedCount > 0 ? `${unratedCount} unrated submissions in the memes wave` : "Quick vote";
  const title = unratedCount > 0 ? `${unratedCount} unrated` : "Quick vote";
  const t2 = `tw-flex tw-items-center tw-gap-x-1.5 tw-rounded-full tw-border tw-border-solid tw-border-primary-500/30 tw-bg-primary-500/10 tw-px-2.5 tw-py-2 tw-text-primary-300 tw-shadow-[0_12px_24px_rgba(11,93,255,0.2)] tw-transition-colors tw-duration-300 desktop-hover:hover:tw-border-primary-400/40 desktop-hover:hover:tw-bg-primary-500/15 ${className ?? ""}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <MemesWaveZapIcon className="tw-size-4 tw-flex-shrink-0 tw-fill-primary-300/20" />;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] !== unratedCount) {
    t4 = unratedCount > 0 && <span className="tw-text-xs tw-font-semibold">{formatNumberWithCommas(unratedCount)}</span>;
    $[1] = unratedCount;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== label || $[4] !== onOpenQuickVote || $[5] !== onPrefetchQuickVote || $[6] !== t2 || $[7] !== t4 || $[8] !== title) {
    t5 = <button type="button" aria-label={label} title={title} onClick={onOpenQuickVote} onFocus={onPrefetchQuickVote} onMouseEnter={onPrefetchQuickVote} className={t2}>{t3}{t4}</button>;
    $[3] = label;
    $[4] = onOpenQuickVote;
    $[5] = onPrefetchQuickVote;
    $[6] = t2;
    $[7] = t4;
    $[8] = title;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default MemesWaveQuickVoteTrigger;